"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalculator = void 0;
const _1 = require(".");
const enums_1 = require("../enums");
const CALCULATE_FUNCTIONS = {
    [enums_1.EuerDeclarationSubformType.BUSINESS_ASSETS]: {
        [enums_1.EuerDeclarationSubformCalculationMethod.BUSINESS_ASSETS_DEFAULT]: _1.calculateBusinessAssetsSubformResults,
    },
    [enums_1.EuerDeclarationSubformType.CAR_USAGE]: {
        [enums_1.EuerDeclarationSubformCalculationMethod.CAR_USAGE_1_PCT_METHOD]: _1.calculateCarUsageSubform1PctMethodResults,
        [enums_1.EuerDeclarationSubformCalculationMethod.CAR_USAGE_DRIVERS_LOG]: _1.calculateCarUsageSubformDriversLogResults,
    },
    [enums_1.EuerDeclarationSubformType.OFFICE_USAGE]: {
        [enums_1.EuerDeclarationSubformCalculationMethod.OFFICE_USAGE_FLAT_RATE_5_EUR]: _1.calculateOfficeUsageSubformFlatRate5EurResults,
        [enums_1.EuerDeclarationSubformCalculationMethod.OFFICE_USAGE_FULL_COST]: _1.calculateOfficeUsageSubformFullCostResults,
        [enums_1.EuerDeclarationSubformCalculationMethod.OFFICE_USAGE_UP_TO_1250_EUR]: _1.calculateOfficeUsageSubformUpTo1250EurResults,
    },
    [enums_1.EuerDeclarationSubformType.TRAVEL_EXPENSES]: {
        [enums_1.EuerDeclarationSubformCalculationMethod.TRAVEL_EXPENSES_DEFAULT]: _1.calculateTravelExpensesSubformResults,
    },
};
const getCalculator = (type, calculationMethod) => {
    const calculationMethodFunctions = CALCULATE_FUNCTIONS[type];
    return calculationMethodFunctions[calculationMethod];
};
exports.getCalculator = getCalculator;
//# sourceMappingURL=getCalculator.js.map